import { motion } from 'framer-motion';
import Logo from '../../../components/base/Logo';

export default function Hero() {
  const handleScrollToForm = () => {
    const formSection = document.getElementById('registro-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleScrollToEvidence = () => {
    const section = document.getElementById('evidencia-tecnica');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/93f33523c65c53c355ff7c999b82b206.jpg"
          alt="Programa de Verificación Segura Bogotá GESTIÓN AUTOMOTRIZ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A2B3C]/97 via-[#1A2B3C]/88 to-[#1A2B3C]/93"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B3C]/80 via-transparent to-transparent"></div>
      </div>

      <div className="absolute top-0 left-0 right-0 z-20 px-4 md:px-10 py-5 flex items-center justify-between">
        <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
          <Logo className="h-9" />
        </motion.div>
        <motion.div className="flex items-center gap-3" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.1 }}>
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-white/5 border border-white/10 rounded-full">
            <i className="ri-building-2-line text-[#28A745] text-xs"></i>
            <span className="text-white/70 text-xs font-medium">GESTIÓN AUTOMOTRIZ AW2020 SAS</span>
          </div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#28A745]/15 border border-[#28A745]/40 rounded-full text-[#28A745] text-xs font-semibold">
            <i className="ri-map-pin-fill text-xs"></i>
            Bogotá D.C.
          </span>
        </motion.div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 text-center py-28 md:py-36">
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} className="mb-5 flex flex-wrap items-center justify-center gap-2">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#28A745]/15 border border-[#28A745]/40 rounded-full text-[#28A745] text-xs font-bold tracking-wider uppercase">
            <span className="w-1.5 h-1.5 bg-[#28A745] rounded-full animate-pulse"></span>
            Programa de Verificación Segura
          </span>
        </motion.div>

        <motion.h1
          className="text-3xl md:text-5xl lg:text-[3.2rem] font-black text-white leading-tight mb-5 tracking-tight"
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.3 }}
        >
          Asegura tu RTM por{' '}
          <span className="text-[#28A745]">$318.000</span>
          <br className="hidden md:block" />
          {' '}y accede a{' '}
          <span className="text-[#28A745]">beneficios promocionales</span>
        </motion.h1>

        <motion.div
          className="max-w-2xl mx-auto mb-8"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.45 }}
        >
          <div className="bg-white/8 border border-white/15 backdrop-blur-sm rounded-2xl px-6 py-5">
            <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-4">
              Registra tu placa y participa cada jueves en el sorteo vinculado al{' '}
              <span className="text-white font-bold">Premio Mayor de la Lotería de Bogotá</span>.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#28A745]/20 border border-[#28A745]/50 rounded-xl">
                <i className="ri-car-line text-[#28A745] text-base"></i>
                <span className="text-white text-sm font-bold">Inscripción previa</span>
              </div>
              <span className="text-white/40 text-lg font-black hidden sm:block">+</span>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#28A745]/20 border border-[#28A745]/50 rounded-xl">
                <i className="ri-hashtag text-[#28A745] text-base"></i>
                <span className="text-white text-sm font-bold">3 dígitos de tu placa en estricto orden</span>
              </div>
              <span className="text-white/40 text-lg font-black hidden sm:block">=</span>
              <span className="text-white/40 text-sm font-bold sm:hidden">coinciden con</span>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#28A745]/20 border border-[#28A745]/50 rounded-xl">
                <i className="ri-trophy-fill text-[#28A745] text-base"></i>
                <span className="text-white text-sm font-bold">Premio Mayor Lotería de Bogotá</span>
              </div>
              <span className="text-white/40 text-lg font-black hidden sm:block">→</span>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#28A745] rounded-xl">
                <i className="ri-percent-fill text-white text-base"></i>
                <span className="text-white text-sm font-black">hasta el 100% de tu RTM gratis</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.55 }}>
          <motion.button onClick={handleScrollToForm} className="w-full sm:w-auto px-8 py-4 bg-[#28A745] hover:bg-[#218838] text-white font-bold rounded-lg transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-sm tracking-wide" whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
            <i className="ri-car-line text-lg"></i>
            Registrar Vehículo y Activar Beneficios
          </motion.button>
          <motion.button onClick={handleScrollToEvidence} className="w-full sm:w-auto px-7 py-4 border border-white/20 bg-white/5 hover:bg-white/10 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm text-sm" whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
            Ver evidencia técnica
          </motion.button>
        </motion.div>

        <motion.div className="flex flex-wrap justify-center gap-5 md:gap-10" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.7 }}>
          {[
            { icon: 'ri-shield-check-fill', text: 'Diagnóstico con herramienta de última generación' },
            { icon: 'ri-trophy-fill', text: 'Sorteo cada jueves' },
            { icon: 'ri-percent-fill', text: 'Hasta 100% de tu RTM' },
            { icon: 'ri-map-pin-2-fill', text: 'Bogotá D.C.' },
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-2 text-white/55">
              <i className={`${item.icon} text-[#28A745] text-sm`}></i>
              <span className="text-xs font-medium">{item.text}</span>
            </div>
          ))}
        </motion.div>
      </div>

      <motion.div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10" animate={{ y: [0, 8, 0] }} transition={{ duration: 2, repeat: Infinity }}>
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm cursor-pointer" onClick={handleScrollToEvidence}>
          <i className="ri-arrow-down-line text-lg text-white/60"></i>
        </div>
      </motion.div>
    </section>
  );
}
